import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import Button from "../../Button/Button";
import InputFormik from "../../Formik/Input/InputFormik";
import Select from "../../Formik/Select/Select";
import Modal from "../Modal/Modal";
import styles from "./AddBankDetails.module.scss";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import {
  addBankDetailsAction,
  editBankDetailsAction,
} from "../../../../features/user/userSlice";
import csc from "country-state-city";
import { FORMIK_REGEX } from "../../../../utils/constants";
import { validationMessage } from "../../../../Helper/helperfunction";
import { Messages } from "../../../../utils/constants";

const AddBankDetails = ({
  show,
  handleClose,
  address,
  setAddress,
  saveAddress,
  bankDetail,
  getBankDetails,
}) => {
  const dispatch = useDispatch();
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 28.7041,
    lng: 77.1025,
  });
  const [addressDetail, setAddressDetail] = useState({});
  const [sameAddress, setSameAddress] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    account_holder_name: "",
    bank_name: "",
    account_number: "",
    account_type: "",
    routing_number: "",
    ifsc_code: "",
  });

  const options = [
    { value: "Checking", label: "Checking" },
    { value: "Savings", label: "Savings" },
  ];

  const validationSchema = Yup.object({
    account_holder_name: Yup.string()
      .label("Account Holder Name")
      .required(validationMessage("Account Holder Name"))
      .min(1)
      .max(25)
      .matches(
        FORMIK_REGEX.ALPHA,
        "Only alphabets, spaces, and periods are allowed.. No special characters, or numeric are allowed"
      ),
    bank_name: Yup.string()
      .label("Bank Name")
      .required(validationMessage("Bank Name"))
      .min(1)
      .max(25)
      .matches(
        FORMIK_REGEX.ALPHA,
        "Only alphabets, spaces, and periods are allowed.. No special characters, or numeric are allowed"
      ),
    account_type: Yup.string()
      .label("Account Type")
      .oneOf(
        ["Checking", "Savings"],
        "Account type must be either 'Checking' or 'Savings'"
      )
      .required(validationMessage("Account Type")),
    account_number: Yup.string()
      .label("Account Number")
      .required(validationMessage("Account Number"))
      .min(3)
      .max(50)
      .matches(FORMIK_REGEX.NUMBER, Messages?.NUMBERVALIDATION),
    routing_number: Yup.string()
      .label("Routing Number")
      // .required(validationMessage("Routing Number"))
      .max(50)
      .matches(FORMIK_REGEX.NUMBER, Messages?.NUMBERVALIDATION),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      account_holder_name: bankDetail?.account_holder_name,
      bank_name: bankDetail?.bank_name,
      account_number: bankDetail?.account_number,
      account_type: bankDetail?.account_type || "Checking",
      routing_number: bankDetail?.routing_number,
      ifsc_code: bankDetail?.ifsc_code,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      try {
        // Add bank details
        await addBankDetails();

        // Proceed with saving the address
        const finalValues = {
          ...values,
          bankDetails,
        };
        saveAddress(finalValues);
        handleClose();
      } catch (error) {
        console.log("Error during form submission:", error);
      } finally {
        formik.setSubmitting(false);
      }
    },
  });

  const addBankDetails = async () => {
    try {
      const response =
        Object.keys(bankDetail).length > 0
          ? await dispatch(
            editBankDetailsAction({
              account_holder_name: formik.values.account_holder_name,
              bank_name: formik.values.bank_name,
              account_number: formik.values.account_number,
              account_type: formik.values.account_type,
              routing_number: formik.values.routing_number,
              ifsc_code: formik.values.ifsc_code,
              bankId: bankDetail?.bank_uuid,
            })
          )
          : await dispatch(
            addBankDetailsAction({
              account_holder_name: formik.values.account_holder_name,
              bank_name: formik.values.bank_name,
              account_number: formik.values.account_number,
              account_type: formik.values.account_type,
              routing_number: formik.values.routing_number,
              ifsc_code: formik.values.ifsc_code,
            })
          );

      if (response?.status === 200) {
        setBankDetails({});
      }
      getBankDetails();
      handleClose();
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const handleAssetChange = (selected) => {
    formik.resetForm();
    formik.setFieldValue("account_type", selected.value);
  };

  return (
    <>
      <Modal
        show={show}
        handleClose={handleClose}
        title={
          <span onClick={handleClose}>
            <LeftArrowIcon />
            Back
          </span>
        }
        className={styles.add_address}
        hideCloseBtn={true}
      >
        <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <Row>
            {sameAddress || formik.values.address_different ? (
              <>
                <Col sm={12}>
                  <InputFormik
                    name="billingAddress"
                    id="billingAddress"
                    type="text"
                    value={formik.values.billingAddress}
                    label="Billing Address"
                    placeholder="Please enter your billing address"
                    className={styles.input}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                </Col>
                <Col sm={12}>
                  <InputFormik
                    name="billingZipcode"
                    id="billingZipcode"
                    type="text"
                    value={formik.values.billingZipcode}
                    label="Billing Zip Code"
                    placeholder="Please enter your billing zip code"
                    className={styles.input}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                </Col>
                <Col sm={12}>
                  <InputFormik
                    name="billingCity"
                    id="billingCity"
                    type="text"
                    value={formik.values.billingCity}
                    label="Billing City"
                    placeholder="Please enter your billing city"
                    className={styles.input}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    formik={formik}
                  />
                </Col>
              </>
            ) : null}
            <Col sm={12}>
              <InputFormik
                name="account_holder_name"
                value={formik.values.account_holder_name}
                label="Account Holder Name"
                placeholder="Enter account holder name"
                className={styles.input}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                formik={formik}
                maxLength={25}
              />
            </Col>
            <Col sm={12}>
              <InputFormik
                name="bank_name"
                value={formik.values.bank_name}
                label="Bank Name"
                placeholder="Enter bank name"
                className={styles.input}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                formik={formik}
                maxLength={25}
              />
            </Col>
            <Col sm={12}>
              <InputFormik
                name="account_number"
                value={formik.values.account_number}
                label="Account Number"
                placeholder="Enter account number"
                className={styles.input}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                formik={formik}
                maxLength={25}
              />
            </Col>
            <Col sm={12}>
              <Select
                name="account_type"
                default
                // value={formik.values.account_type} // Reflect the selected value
                label="Account Type"
                placeholder="Select account type"
                defaultValue={options[0]}
                options={options}
                className={styles.input}
                onChange={handleAssetChange}
                onBlur={formik.handleBlur}
                formik={formik}
              />
            </Col>

            <Col sm={12}>
              <InputFormik
                name="routing_number"
                value={formik.values.routing_number}
                label="Routing Number"
                placeholder="Enter routing number"
                className={styles.input}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                formik={formik}
                maxLength={50}
              />
            </Col>
            <Col sm={12}>
              <InputFormik
                name="ifsc_code"
                value={formik.values.ifsc_code}
                label="IFSC Code (Optional)"
                placeholder="Enter IFSC Code"
                className={styles.input}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                formik={formik}
                maxLength={50}
              />
            </Col>
            <Col sm={12}>
              <Button
                type="button"
                fluid={true}
                className={styles.add_btn}
                disabled={formik.isSubmitting} // Disable button while submitting
                onClick={(e) => {
                  formik.handleSubmit(e);
                }}
              >
                {Object.keys(bankDetail).length > 0
                  ? "Edit Bank Details"
                  : "Add Bank Details"}
              </Button>
            </Col>
          </Row>
        </form>
      </Modal>
    </>
  );
};

export default AddBankDetails;
